import { render, staticRenderFns } from "./ClientCreate.vue?vue&type=template&id=9e5ee304&"
import script from "./ClientCreate.vue?vue&type=script&lang=ts&"
export * from "./ClientCreate.vue?vue&type=script&lang=ts&"
import style0 from "./ClientCreate.vue?vue&type=style&index=0&id=9e5ee304&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports